import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMP_EXITS);

const state = {
    data: [],
    exits: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
    },

    addEmployee: (state, payload) => {
        state.exits.push(payload);
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`);
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async fetchExits({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                commit('setExits', res.data.rows);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/', payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('addEmployee', payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};